__turbopack_context__.v({
  "MenuBtn": "H_atcG_MenuBtn",
  "additionalContainer": "H_atcG_additionalContainer",
  "downloadBtn": "H_atcG_downloadBtn",
  "everything": "H_atcG_everything",
  "fadeMenu": "H_atcG_fadeMenu",
  "isOpen": "H_atcG_isOpen",
  "isSticky": "H_atcG_isSticky",
  "isTransparent": "H_atcG_isTransparent",
  "leftContain": "H_atcG_leftContain",
  "loginRegister": "H_atcG_loginRegister",
  "logo": "H_atcG_logo",
  "logoLink": "H_atcG_logoLink",
  "masthead": "H_atcG_masthead",
  "menuActions": "H_atcG_menuActions",
  "menuOpen": "H_atcG_menuOpen",
  "menuRight": "H_atcG_menuRight",
  "mobile": "H_atcG_mobile",
  "mobile-menu": "H_atcG_mobile-menu",
  "mobileBackground": "H_atcG_mobileBackground",
  "mobileWrap": "H_atcG_mobileWrap",
  "nonSticky": "H_atcG_nonSticky",
  "offCanvas": "H_atcG_offCanvas",
  "overview": "H_atcG_overview",
  "personalise": "H_atcG_personalise",
  "primary": "H_atcG_primary",
  "sticky": "H_atcG_sticky",
  "text": "H_atcG_text",
  "tooltip": "H_atcG_tooltip",
  "tooltip-text": "H_atcG_tooltip-text",
  "widthAuto": "H_atcG_widthAuto",
});
